// Clear local storage and cookies to log out of site only
export const siteLogout = () => {
    localStorage.clear();
    document.cookie.split(";").forEach(cookie => document.cookie = cookie.trim().split("=")[0] + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/');
    window.location.href = window.location.href;
};
